import React, { useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Home from "./Pages/Home/Home";
import DoorStopHome from "./Pages/DoorStop/Home";
import PlayCompanyIntro from "./Pages/Home/Componets/PlayCompanyIntro";
import ContactUsModal from "./Compoents/Modal/ContactUsModal";
import useAppStore from "./StateStore/ZustandStore";
import { View } from "react-native";
import { backgroundLight } from "./Constants/Colors";
import { HelmetProvider } from "react-helmet-async";
import Seo from "./Seo";

function App() {
  const modal = useAppStore((state) => state.modal);
  const setModal = useAppStore((state) => state.setModal);

  const handleCloseModal = useCallback(() => setModal(false), [setModal]);

  const handleContactSubmit = useCallback(
    (data) => {
      console.log("Contact Us Data:", data);
      setModal(false);
    },
    [setModal]
  );

  const renderModal = () => {
    switch (modal) {
      case "CompanyIntro":
        return <PlayCompanyIntro onClose={handleCloseModal} />;

      case "ContactUs":
        return (
          <ContactUsModal
            visible={!!modal}
            onClose={handleCloseModal}
            onSubmit={handleContactSubmit}
          />
        );

      default:
        return null;
    }
  };

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Seo />
        <Routes>
          <Route
            path="/"
            element={
              <View style={{ backgroundColor: backgroundLight, alignItems: "center" }}>
                {renderModal()}
                <Header />
                <Home />
                <Footer />
              </View>
            }
          />
          <Route path="/doorstop" element={<DoorStopHome />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
